import React from 'react';

interface MeltBarSlotContextValue {
  /** Whether the record header melt bar is currently visible */
  isMelted: boolean;
  /** The actual DOM node of the slot inside the melt bar (null when melt bar is hidden) */
  slotNode: HTMLDivElement | null;
}

const MeltBarSlotContext = React.createContext<MeltBarSlotContextValue>({
  isMelted: false,
  slotNode: null,
});

export function MeltBarSlotProvider({
  isMelted,
  slotNode,
  children,
}: {
  isMelted: boolean;
  slotNode: HTMLDivElement | null;
  children: React.ReactNode;
}) {
  const value = React.useMemo(
    () => ({ isMelted, slotNode }),
    [isMelted, slotNode],
  );

  return (
    <MeltBarSlotContext.Provider value={value}>
      {children}
    </MeltBarSlotContext.Provider>
  );
}

export function useMeltBarSlot() {
  return React.useContext(MeltBarSlotContext);
}
